import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id, pagination }) => {
        const { page, pageSize: limit } = pagination;

        try {
            const [projectsRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listProjects', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listProjects', {
                    mid: id === undefined ? [] : id
                })
            ]);

            if (projectsRes.error || selectedRes.error) {
                throw new Error(projectsRes.msg || selectedRes.msg);
            }

            const projects = { data: projectsRes.data, count: projectsRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = projects.data.find(
                    itemProject => itemProject.mid === itemSelected.mid
                );
                if (!item) {
                    projects.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return projects;
        } catch (err) {
            console.error(err);
        }
    }
};
